/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'
// import { get } from 'lodash'
/**
 * Import
 * - Store
 */
import { RootState } from '../../../../../store'

/**
 * Import
 * - Actions
 */
import {
    setStep03,
    resetQuotes,
    setStep03Renewals,
    getRenewalVariation,
    getQuoteVariation
} from '../../../../../actions'

/**
 * Import
 * - Page component
 */
import Step03w from '../components/step03wView'

const mapStateToProps = (state: RootState, props: any) => {
    return {
        quote: state.quote,
        fullQuote: props.fullQuote,
        isWineSpiritsSteve: props.isWineSpiritsSteve,
    }
}

export default connect(
    mapStateToProps,
    {
        setStep03: setStep03,
        setStep03Renewals: setStep03Renewals,
        resetQuotes: resetQuotes,
        getRenewalVariation,
        getQuoteVariation,
    }
)(Step03w)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Policies/MTA/containers/Step03w.tsx